module.exports = __webpack_public_path__ + "images/408b4180e24f53b97782d232a8f1f2ff.gif";